module.exports = __webpack_public_path__ + "img/28d-produtividade-afastamentos.59490c1b.png";